import { createSlice } from '@reduxjs/toolkit';
import { createGroup, IGroup } from '../../../models/groups';

interface IGroupState {
    group: IGroup,
    groups: IGroup[],
    isLoading: boolean,
};

const initialState: IGroupState = {
    group: createGroup({}),
    groups: [],
    isLoading: false,
};

export const groupsSlice = createSlice({
    name: 'groups',
    initialState,
    reducers: {
        setGroup: (state, action) => {
            state.isLoading = false;
            state.group = action.payload.group;
        },
        setGroups: (state, action) => {
            state.isLoading = false;
            state.groups = action.payload.groups;
        },
        startLoadingGroups: (state) => {
            state.isLoading = true;
        },
        updateGroups: (state, action) => {
            state.isLoading = false;

            const updated: IGroup[] = state.groups.map((item: IGroup) => {
                if (item.id === action.payload.group.id)
                    return action.payload.group;
                return item;
            });
            state.groups = updated;
        },
    }
});

// Action creators are generated for each case reducer function
export const {
    setGroup,
    setGroups,
    startLoadingGroups,
    updateGroups
} = groupsSlice.actions;